/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup';
import Image from 'react-bootstrap/Image';
import { CheckCircleIcon } from '@heroicons/react/solid';

import * as S from './styles';

import '../../../../../node_modules/flag-icons/css/flag-icons.min.css';

export interface IHeroListProps {
  listItems: {
    key: string;
    title: string;
    subtitle: string;
    icon: string;
    flag?: sting;
    verified?: boolean;
  }[];
}

export const HeroList = (props: IHeroListProps) => {
  const { listItems } = props;
  const _renderList = () => {
    return (
      <>
        {listItems.map((item, index) => {
          return (
            <Col xs={12} md={4} key={`${item?.key}-${index}`}>
              <ListGroup>
                <S.IconContainer>
                  <S.IconImage src={item?.icon} />
                  <div className="px-3 pb-2">
                    <S.Title className="fs-6 mb-0 pb-0">
                      {item?.title}
                      {item?.verified && (
                        <CheckCircleIcon
                          className={`icon icon-xxs text-success me-1`}
                        />
                      )}
                    </S.Title>
                    <S.SubTitle className="fs-6 mb-0 w-100">
                      {item?.flag && (
                        <span class={`fi fi-${item?.flag} fis`}></span>
                      )}{' '}
                      {item?.subTitle}
                    </S.SubTitle>
                  </div>
                </S.IconContainer>
              </ListGroup>
            </Col>
          );
        })}
      </>
    );
  };
  return <Row className="flex-start">{_renderList()}</Row>;
};

HeroList.defaultProps = {
  listItems: [],
};
